module.exports = __webpack_public_path__ + "static/portada-2eca789e8903b33751c83e89a1260024.png";